// src/api/projects.ts
import api from "./api";

export interface ProjectTaskCounts {
  total?: number;
  open?: number;
  closed?: number;
  by_status?: Record<string, number>;
}

export interface Project {
  id: string;
  name: string;
  description: string | null;
  code: string | null;
  client_id: string | null;
  client_name: string | null;
  status: 'ACTIVE' | 'ON_HOLD' | 'COMPLETED' | 'ARCHIVED';
  start_date: string | null;
  end_date: string | null;
  created_by: string | null;
  is_active: boolean;
  created_at: string | null;
  updated_at: string | null;
  headOfficeID: string | null;
  branchID: string | null;
  task_counts?: ProjectTaskCounts;
}

export interface ProjectCreatePayload {
  name: string;
  description?: string;
  code?: string;
  client_id?: string | null;
  status?: 'ACTIVE' | 'ON_HOLD' | 'COMPLETED' | 'ARCHIVED';
  start_date?: string;
  end_date?: string;
}

export interface ProjectUpdatePayload {
  name?: string;
  description?: string;
  code?: string;
  client_id?: string | null;
  status?: 'ACTIVE' | 'ON_HOLD' | 'COMPLETED' | 'ARCHIVED';
  start_date?: string;
  end_date?: string;
}

export const projectsApi = {
  list: (params?: {
    search?: string;
    status?: string;
    client_id?: string;
    include_archived?: boolean;
    page?: number;
    page_size?: number;
  }) => api.get('/projects', { params }),

  get: (projectId: string) => api.get(`/projects/${projectId}`),

  create: (payload: ProjectCreatePayload) => api.post('/projects', payload),

  update: (projectId: string, payload: ProjectUpdatePayload) =>
    api.patch(`/projects/${projectId}`, payload),

  delete: (projectId: string) => api.delete(`/projects/${projectId}`),

  reopen: (projectId: string) => api.post(`/projects/${projectId}/reopen`),

  complete: (projectId: string) => api.post(`/projects/${projectId}/complete`),

  listTasks: (projectId: string, includeClosed = true) =>
    api.get(`/projects/${projectId}/tasks?include_closed=${includeClosed}`),
};

export default projectsApi;
